
/////////////////////////
// iPhone Menu JavaScript
////////////////////////
let currentLevel = 1;
let levelHistory = [1];

document.addEventListener('click', function(e) {
    if (!e.target.closest('.mobileMenu')) {
        return;
    }
    
    let target = e.target;
    let submenuId = target.getAttribute('data-submenu');
    
    if (!submenuId && target.parentElement) {
        submenuId = target.parentElement.getAttribute('data-submenu');
    }
    
    if (submenuId) {
        e.preventDefault();
        console.log('Navigating to submenu:', submenuId);
        navigateToLevel(submenuId);
    }
});

function navigateToLevel(targetLevel) {
    console.log('navigateToLevel called with:', targetLevel);
    
    const currentLevelElement = document.getElementById(`menu-level-${currentLevel}`);
    const targetLevelElement = document.getElementById(`menu-level-${targetLevel}`);
    
    console.log('Current element:', currentLevelElement);
    console.log('Target element:', targetLevelElement);
    
    if (!targetLevelElement) {
        console.error('Target level not found:', `menu-level-${targetLevel}`);
        return;
    }
    
    if (!currentLevelElement) {
        console.error('Current level not found:', `menu-level-${currentLevel}`);
        return;
    }
    
    levelHistory.push(currentLevel);
    console.log('Level history:', levelHistory);
    
    // 1. Level 
    targetLevelElement.style.transition = 'none';
    targetLevelElement.style.transform = 'translateX(100%)';
    targetLevelElement.classList.remove('slide-left', 'slide-right');
    
    // 2. Level
    currentLevelElement.classList.remove('active-level');
    currentLevelElement.style.transform = 'translateX(-100%)';
    
    // 3. Level
    requestAnimationFrame(() => {
        targetLevelElement.style.transition = '';  
        targetLevelElement.style.transform = 'translateX(0)';
        targetLevelElement.classList.add('active-level');
        
        const backButton = targetLevelElement.querySelector('.menu-back');
        if (backButton) {
            backButton.classList.add('active');
        }
    });
    
    currentLevel = targetLevel;
    console.log('Current level set to:', currentLevel);
}

window.goBackToLevel = function(targetLevel) {
    console.log('goBackToLevel called with:', targetLevel);
    
    const currentLevelElement = document.getElementById(`menu-level-${currentLevel}`);
    const targetLevelElement = document.getElementById(`menu-level-${targetLevel}`);
    
    if (!targetLevelElement || !currentLevelElement) {
        console.error('Elements not found for back navigation');
        return;
    }
    
    levelHistory.pop();
    
    // 1. Level
    targetLevelElement.style.transition = 'none';
    targetLevelElement.style.transform = 'translateX(-100%)';
    targetLevelElement.classList.remove('slide-left', 'slide-right');
    
    // 2. Level
    currentLevelElement.classList.remove('active-level');
    currentLevelElement.style.transform = 'translateX(100%)';
    
    const currentBackButton = currentLevelElement.querySelector('.menu-back');
    if (currentBackButton) {
        currentBackButton.classList.remove('active');
    }
    
    // 3. Level
    requestAnimationFrame(() => {
        targetLevelElement.style.transition = ''; 
        targetLevelElement.style.transform = 'translateX(0)';
        targetLevelElement.classList.add('active-level');
        
        if (targetLevel != 1 && targetLevel != '1') {
            const targetBackButton = targetLevelElement.querySelector('.menu-back');
            if (targetBackButton) {
                targetBackButton.classList.add('active');
            }
        }
    });
    
    currentLevel = targetLevel;
    console.log('Returned to level:', currentLevel);
};

// Reset function
window.resetToMainMenu = function() {
    console.log('Resetting to main menu');
    
    const allLevels = document.querySelectorAll('.menu-level');
    allLevels.forEach((level, index) => {
        level.classList.remove('slide-left', 'slide-right');
        level.style.transform = '';
        
        // Only first level should have active-level class
        if (index === 0 || level.id === 'menu-level-1') {
            level.classList.add('active-level');
        } else {
            level.classList.remove('active-level');
        }
        
        const backButton = level.querySelector('.menu-back');
        if (backButton) {
            backButton.classList.remove('active');
        }
    });
    
    currentLevel = 1;
    levelHistory = [1];
};

// Menu toggle functions
window.toggleMobileMenu = function() {
    const menu = document.querySelector('.mobileMenu');
    const overlay = document.querySelector('.menu-overlay');
    
    menu.classList.toggle('active');
    overlay.classList.toggle('active');
    
    if (menu.classList.contains('active')) {
        document.body.style.overflow = 'hidden';
    } else {
        document.body.style.overflow = '';
        if (typeof resetToMainMenu === 'function') {
            resetToMainMenu();
        }
    }
};

window.closeMobileMenu = function() {
    const menu = document.querySelector('.mobileMenu');
    const overlay = document.querySelector('.menu-overlay');
    
    menu.classList.remove('active');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
    
    if (typeof resetToMainMenu === 'function') {
        setTimeout(resetToMainMenu, 300);
    }
};
/////////////////////
// END OF IPHONE MENU
/////////////////////